import { Controller } from "@hotwired/stimulus";
import { cloneDialog } from "@/utilities/template_helpers";

export default class extends Controller {
  static targets = ["close"]
  static values = {
    open: Boolean,
    isTurboModal: Boolean,
  }

  connect() {
    if (this.openValue) this.showModal();
  }

  showModal() {
    if (this.isTurboModalValue) {
      this.element.addEventListener("close", () => {
        const turboFrame = this.element.parentElement
        turboFrame.removeAttribute("src")
        turboFrame.removeAttribute("complete")

        setTimeout(() => {
          this.element.remove()
        }, 300)
      }, { once: true })
    }

    this.element.showModal()
  }

  lockModal() {
    this.element.setAttribute("closedby", "none")
  }

  close() {
    this.element.close()
  }

  preventExit(event) {
    this.closeTarget.dataset.action = "modal#showConfirmation"
    const { dialog, dialogElement, confirmButton } = cloneDialog(event.detail, "get")
    dialogElement.dataset.modalOpenValue = false
    confirmButton.dataset.action = "modal#confirmExit"
    this.element.appendChild(dialog)
  }

  showConfirmation() {
    this.element.querySelector("dialog").showModal()
  }

  confirmExit() {
    this.element.parentElement.close()
  }
}
